import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Route, Routes } from 'react-router-dom'
import { StoreState } from '../store'
import Login from '../Pages/Login'
import Cadastro from '../Pages/Cadastro'
import Plataform from '../Pages/Plataform'
import EmailVerification from '../Pages/EmailVerification'
import MinhaConta from '../Pages/MinhaConta'
import Pagar from '../Pages/Pagar'
import NotFound from '../Pages/NotFound'
import Dashboard from '../Pages/Dashboard'
import Pagamento from '../Pages/Pagamento'
import Extratos from '../Pages/Extratos'
import Instituicao from '../Pages/Instituicao'
import Termos from '../Pages/Termos'
import Senha from '../Pages/Senha'
import Favoritos from '../Pages/Favoritos'
import RecorrenciasGerenciar from '../Pages/RecorrenciasGerenciar'
import RecorrenciaIndividual from '../Pages/RecorrenciaIndividual'
import CobrancaPagar from '../Pages/CobrancaPagar'
import LinkCriar from '../Pages/LinkCriar'
import CobrancasGerenciar from '../Pages/CobrancasGerenciar'
import DomicilioPagamento from '../Pages/DomicilioPagamento'
import CobrancaIndividual from '../Pages/CobrancaIndividual'
import CobrancaCriar from '../Pages/CobrancaCriar'
import PagamentoCriar from '../Pages/PagamentoCriar'
import RecuperarSenha from '../Pages/RecuperarSenha'
import CriarNovaSenha from '../Pages/CriarNovaSenha'
import SolicitacoesAcesso from '../Pages/SolicitacoesAcesso'
import Documentos from '../Pages/Documentos'

export default function Router() {
    const { isLoggedIn } = useSelector((state: StoreState) => state.auth)
    function closedRoutes(
        element: React.ReactElement | React.ReactNode,
        closed: boolean = false
    ) {
        if (closed && !isLoggedIn) {
            return <Navigate to="/login" />
        }
        return element
    }

    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Cadastro />} />
            <Route path="/" element={closedRoutes(<Plataform />, true)}>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="pagamento" element={<Pagamento />} />
                <Route path="pagamento/criar" element={<PagamentoCriar />} />
                <Route path="extratos" element={<Extratos />} />
                {/* <Route path='recebimentos' element={<Recebimentos />} /> */}
                <Route path="pagar" element={<Pagar />} />
                <Route path="favoritos" element={<Favoritos />} />
                <Route path="old/cobranca/criar" element={<LinkCriar />} />

                <Route path="cobranca/criar" element={<CobrancaCriar />} />
                <Route path="cobrancas" element={<CobrancasGerenciar />}>
                    {/* <Route path="gerenciar" element={<LinkGerenciar />} /> */}
                    {/* <Route path="aprovar" element={<LinkAprovar />} /> */}
                    {/* <Route path='pagar/:id' element={<LinkPagar />}/> */}
                </Route>
                <Route path="cobranca/:id" element={<CobrancaIndividual />} />
                {/* <Route path='link-pagar/:id' element={<LinkPagar />}/> */}
                <Route path="recorrencia" element={<RecorrenciasGerenciar />}>
                    {/* <Route
                        path="gerenciar"
                        element={<RecorrenciasGerenciar />}
                    /> */}
                    {/* <Route path="criar" element={<RecorrenciaCriar />} /> */}
                    {/* <Route path='link' element={<RecorrenciaLink />}/> */}
                    {/* <Route path='aprovar' element={<RecorrenciasAprovar />}/> */}
                </Route>
                <Route
                    path="recorrencia/:id"
                    element={<RecorrenciaIndividual />}
                />
                <Route path="contrato/:id" element={<Pagar />} />

                <Route path="minhaconta" element={<MinhaConta />}>
                    <Route path="instituicao" element={<Instituicao />} />
                    <Route
                        path="domicilio-pagamento"
                        element={<DomicilioPagamento />}
                    />
                    <Route path="documentos" element={<Documentos />} />
                    <Route path="senha" element={<Senha />} />
                    <Route path="termos" element={<Termos />} />
                    <Route
                        path="solicitacoes-de-acesso"
                        element={<SolicitacoesAcesso />}
                    />
                </Route>
                <Route path=":id" element={<CobrancaPagar />} />
            </Route>
            <Route path="/recuperar-senha" element={<RecuperarSenha />} />
            <Route path="/nova-senha" element={<CriarNovaSenha />} />

            <Route
                path="/verification/:id/:token"
                element={<EmailVerification />}
            />
            <Route path="*" element={<NotFound />} />
        </Routes>
    )
}
